export const createAuthHeader = (accessToken: string): string => {
  return accessToken ? `Bearer ${accessToken}` : '';
};
